import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import Badge from './Badge';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

export default class HeaderSearchRefreshFilterOptions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: this.props.searchText,
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    render() {
        return (
            <div className={'card-search-filter'}>
                {this.renderSearch()}
                {this.renderFilter()}
                {this.renderRefresh()}
                {this.renderAdd()}
                {this.renderMore()}
                {this.renderCollapsed()}
            </div>
        );
    }

    renderSearch() {
        const { collapsed, enableSearch } = this.props;
        const noRender = collapsed || !enableSearch;

        if ( noRender ) return null;

        return (
            <form
                className="card-search"
                onSubmit={this.onSubmit}
            >
                <div
                    className="input-group m-b-0"
                    style={{ marginBottom: 0 }}
                >
                    <div className="form-line">
                        <input
                            type="text"
                            className="form-control date"
                            placeholder={I18nUtils.tr('TR_BUSCAR')}
                            value={this.state.searchText}
                            onChange={this.onChange}/>
                    </div>
                    <span
                        className="input-group-addon"
                        style={{ padding: 0 }}
                    >
                        <button
                            className="button-icon"
                            type="submit"
                        >
                            <i className="material-icons">
                                {'search'}
                            </i>
                        </button>
                    </span>
                </div>
            </form>
        );
    }

    renderFilter() {
        const { collapsed, enableFilter, filterOptions } = this.props;
        const noRender = collapsed || !enableFilter;

        if ( noRender ) return null;

        return (
            <li className="dropdown">
                <button
                    className="button-icon"
                    data-toggle="dropdown"
                >
                    <i className="material-icons">
                        {'filter_list'}
                    </i>
                </button>
                <ul className="dropdown-menu pull-right">
                    {
                        filterOptions.map((object, i) => {
                            const {
                                color,
                                active,
                                onClick,
                                title,
                            } = object;

                            return (
                                <li
                                    key={i}
                                    className={active ? 'active' : ''}
                                >
                                    <a onClick={onClick ? onClick : null}>
                                        {color ? <Badge color={color}/> : null}{title}
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>
            </li>
        );
    }

    renderRefresh() {
        const { collapsed, enableRefresh, onRefresh } = this.props;
        const noRender = collapsed || !enableRefresh;

        if ( noRender ) return null;

        return (
            <li>
                <button
                    className="button-icon"
                    onClick={onRefresh}
                >
                    <i className="material-icons">
                        {'loop'}
                    </i>
                </button>
            </li>
        );
    }

    renderAdd() {
        const { addRoute } = this.props;
        const noRender = !addRoute;

        if ( noRender ) return null;

        return (
            <li>
                <button
                    className="button-icon"
                >
                    <Link to={addRoute}>
                        <i className="material-icons">
                            {'add'}
                        </i>
                    </Link>
                </button>
            </li>
        );
    }

    renderOnFilter() {
        if ( this.props.onFilter ) {
            return null;
        }

        return (
            <li>
                <a onClick={this.props.onAdd}>
                    <i className="material-icons">flight</i>
                </a>
            </li>
        );
    }

    renderBadgeColor(option) {
        if ( option.color ) {
            return <Badge color={option.color}/>;
        }
        return null;
    }

    renderMore() {
        const { collapsed, moreOptions } = this.props;
        const noRender = collapsed || !moreOptions || moreOptions.length === 0;

        if ( noRender ) return null;

        return (
            <li className="dropdown">
                <button
                    className="button-icon"
                    data-toggle="dropdown"
                >
                    <i className="material-icons">
                        {'more_vert'}
                    </i>
                </button>
                <ul className="dropdown-menu pull-right">
                    {
                        moreOptions.map((object, i) => {
                            const {
                                active,
                                onClick,
                                title,
                                disabled,
                            } = object;

                            const classes = classNames({
                                'active': active,
                                'disabled': disabled,
                            });

                            const onClickClasses = classNames({
                                'pointer-disabled': disabled,
                            });

                            return (
                                <li
                                    key={i}
                                    className={classes}
                                >
                                    <a className={onClickClasses}
                                       onClick={onClick && !disabled ? onClick : null}>
                                        {title}
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>
            </li>
        );
    }

    renderCollapsed() {
        const {
            collapsed,
            onCollapsed,
        } = this.props;

        if ( collapsed === null || !onCollapsed ) return null;

        return (
            <li>
                <button
                    className="button-icon"
                    onClick={() => onCollapsed(!collapsed)}
                >
                    <i className="material-icons">
                        {collapsed ? 'expand_more' : 'expand_less'}
                    </i>
                </button>
            </li>
        );
    }

    onSubmit(event) {
        event.preventDefault();
        this.props.onSearch(this.state.searchText);
    }

    onChange(event) {
        this.setState({ searchText: event.target.value });
    }

}

HeaderSearchRefreshFilterOptions.propTypes = {
    onRefresh: PropTypes.func,
    onSearch: PropTypes.func,
    searchText: PropTypes.string,
    enableFilter: PropTypes.bool,
    enableSearch: PropTypes.bool,
    enableRefresh: PropTypes.bool,
    filterOptions: PropTypes.array,
    moreOptions: PropTypes.array,
    cardSearchFilterEnabled: PropTypes.bool,
    onCollapsed: PropTypes.func,
    collapsed: PropTypes.bool,
};

HeaderSearchRefreshFilterOptions.defaultProps = {
    onRefresh: () => {},
    onSearch: (search) => {},
    searchText: '',
    filterOptions: [],
    moreOptions: [],
    enableFilter: true,
    enableSearch: true,
    enableRefresh: true,
    cardSearchFilterEnabled: true,
    collapsed: null,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/HeaderSearchRefreshFilterOptions.jsx